import React from "react";

export const IfElse = ({ condition, children, elseIf }) =>
  condition ? <>{children}</> : <>{elseIf}</>;

IfElse.defaultProps = { condition: true };